import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { Loader, DataList, CustomModal } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useFilter from './useFilter';
import { columnConfigs } from './listConfig';

const PayInDetails: React.FC<{}> = () => {
	const { showLoader, getPayInData, setChangeFilter, forceUpdate } = useFilter();
	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				<Button
					kind='primary'
					size='compact'
					onClick={() => {
						setChangeFilter(true);
					}}>
					Change Filter
				</Button>
			</div>
			<DataList
				fetchData={getPayInData}
				columnConfigs={columnConfigs}
				hideActions
				rowHeight={50}
				entity={LIST_ENTITY_NAMES.PAYIN_DETAILS}
				globalForceUpdate={forceUpdate}
				height='calc(100vh - 220px)'
				filterable={false}
			/>
			<CustomModal />
		</>
	);
};

export default PayInDetails;
